<agr-dialog [data]="data" (alt)="alt()" (cancel)="cancel()" (confirm)="confirm()">
  <img
    [src]="data.imagePath"
    [alt]="'Diseases.altText' | translate: { diseaseName: data.diseaseName }"
    width="500"
    height="500"
  />
</agr-dialog>
